import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Allocations = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Allocations
        </Typography>
        <Typography variant="body1">
          Batch allocation functionality coming soon...
        </Typography>
      </Box>
    </Container>
  );
};

export default Allocations; 